import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions, PreloadAllModules } from '@angular/router';

import { LoginRoutes } from './login/login.routes';
import { TemplateRoutes } from './_template/template.routes';

const routes: Routes = [
  ...LoginRoutes,
  ...TemplateRoutes
];

const routerOptions: ExtraOptions = {
    // preloadingStrategy: PreloadAllModules,
    useHash: true,
    relativeLinkResolution: 'legacy',
    
  };

@NgModule({
  imports: [
    RouterModule.forRoot(routes, routerOptions)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
